<template>
  <b-modal size="md" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
    <b-container>
      <b-row>
        <b-col>
          <b-form @submit.prevent="submitForm">
            <lg-form-input sm="12" md="12" v-model="form.municipio" label="Descricao: *" required></lg-form-input>

            <lg-finder-page-unidade-federativa v-model="form.uf" :value="ufObject" label="Estado:*" id="finderUf"
              invalidFeedback="UF deve ser informada!" description="" :prefix="updatedPrefix"
              @onselect="handleUfSelect" />

            <b-form-group target="situacaoCidade" label="Status:*">
              <b-form-radio-group id="situacaoCidade" size="sm" v-model="form.situacao" :options="options"
                name="situacao-options" class="d-flex">
              </b-form-radio-group>
            </b-form-group>

            <div class="d-flex justify-content-center mt-3">
              <b-button id="aprovarCidade" type="submit" variant="success" style="height: 30px" pill size="sm">
                <div class="btn-size-alinhamento">
                  <b-icon icon="check-circle" />
                </div>
                <b-tooltip target="aprovarCidade" title="Aprovar" triggers="hover" class="text-right"></b-tooltip>

              </b-button>
              <b-button id="cancelarCidade" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                variant="danger">
                <div class="btn-size-alinhamento">
                  <b-icon icon="x-circle" />
                </div>
                <b-tooltip target="cancelarCidade" title="Cancelar" triggers="hover" class="text-right"></b-tooltip>

              </b-button>
            </div>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import LgFinderPageUnidadeFederativa from "@/components/Finders/LgFinderPageUnidadeFederativa.vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
    LgFinderPageUnidadeFederativa,
  },
  data() {
    return {
      showModal: true,
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      form: {
        descricao: "",
        uf: {},
        situacao: 1,
      },
    };
  },
  mixins: [ConfirmMixin, FormResourceMixin],
  props: {
    prefix: {
      type: Array,
      required: true,
    },
    id: {
      type: Number,
      default: null,
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/cidade`);
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    }
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, "Cadastro"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {

    async submitForm() {


      if (!this.form.uf || !this.form.uf.id) {
        this.$notify({
          type: "danger",
          message: "Seleção da Unidade Federativa é obrigatória",
        });
        return;
      }

      try {
        await this.$service.save(this.form);
        this.$notify({
          type: "success",
          message: 'Registro salvo com sucesso'
        });
        this.cancelar();

      } catch (e) {
        this.$notify({
          type: "danger",
          message: 'Este registro já está cadastrado'
        });
        return;
      }



    },

    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>
